<template>
  <router-view />
</template>

<script setup>
import { defineComponent } from 'vue';

defineComponent({
  name: 'App',
});
</script>
